import React, { useCallback } from 'react';
import PropTypes from 'prop-types';

import { TooltipWithErrorBoundary as Tooltip, TooltipConstants, removeClickable } from '@Components/Tooltip';
import { placeRightAlignBottom } from '@Pages/Heatmap/HeatmapTooltipHeaders/tooltipOverridePosition';
import { getHoverTooltipContent } from '@Pages/Heatmap/HeatmapTooltipHeaders/getTooltipContent';
import { TooltipEvents } from './constants';

function HeatmapTooltipHeadersHoverRows({ dataMap, type }) {
  const onClose = useCallback(() => removeClickable(TooltipConstants.ids.HeatmapTooltipHeadersRows), []);

  return (
    <Tooltip
      id={TooltipConstants.ids.HeatmapTooltipHeadersRows}
      elsTooltip={false}
      className="heatmap-tooltip rs-tooltip-big"
      place="right"
      clickable
      overridePosition={placeRightAlignBottom}
      getContent={(index) => (index ? getHoverTooltipContent({ data: dataMap[index], type, onClose }) : null)}
      hideDelay={100}
      globalEventOff={TooltipEvents.ON_HOVER_EVENT}
      afterShow={TooltipEvents.hideOnClickTooltips}
    />
  );
}

HeatmapTooltipHeadersHoverRows.propTypes = {
  dataMap: PropTypes.object,
  type: PropTypes.string,
};

export default HeatmapTooltipHeadersHoverRows;
